import { render, staticRenderFns } from "./OverrideFileEditor.vue?vue&type=template&id=3a935ea2&scoped=true"
import script from "./OverrideFileEditor.vue?vue&type=script&lang=js"
export * from "./OverrideFileEditor.vue?vue&type=script&lang=js"
import style0 from "./OverrideFileEditor.vue?vue&type=style&index=0&id=3a935ea2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a935ea2",
  null
  
)

export default component.exports